<template>
  <div class="container">
    <div class="block">
      <div class="content-inner-wrap">
        <van-form
          label-width="80px"
          :model="ruleForm"
          ref="ruleForm"
          @submit="submitForm"
          :show-error="false"
          validate-first
          validate-trigger="onSubmit"
        >
          <van-field
            label="工作室名称"
            name="name"
            :rules="rules.name"
            v-model="ruleForm.name"
          >
          </van-field>
          <van-field
            label="工作室LOGO"
            name="fileList"
            :rules="rules.fileList"
            v-model="ruleForm.fileList"
          >
            <template slot="input">
              <my-el-upload
                :action="upload_url"
                class="upload-demo"
                :file-list="fileList"
                :on-remove="onRemove"
                :on-change="onChangeLogo"
                :before-upload="onBeforeUpload"
                name="image"
                accept="image/png,image/jpeg,image/bmp"
                list-type="picture"
              >
                <van-button size="small" class="uploadBtn" native-type="button">
                  <i class="icon icon-upload"></i><span>上传文件</span>
                </van-button>
                <div slot="tip" class="el-upload__tip">
                  <p>请上传工作室的LOGO图片，建议尺寸为：200*200</p>
                  <p>格式支持PNG、BMP、JPG，图片大小控制在10M以内</p>
                </div>
              </my-el-upload>
            </template>
          </van-field>
          <van-field
            label="工作室简介"
            maxlength="150"
            name="description"
            :rules="rules.description"
            type="textarea"
            v-model="ruleForm.description"
            :rows="4"
          >
          </van-field>
          <van-field
            label="联系方式"
            name="contact"
            :rules="rules.contact"
            v-model="ruleForm.contact"
          >
          </van-field>
          <van-button
            class="largeCenterBtn"
            type="primary"
            native-type="submit"
          >
            提交申请
          </van-button>
        </van-form>
        <van-button
          class="largeCenterBtn cancelBtn"
          type="primary"
          @click="$router.back()"
          >取消</van-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import MyUpload from '../../../components/MyUpload.vue';
import { UPLOAD_URL, isEmail, isIntNum, isValidFileSize } from '../CONST';
import { studioRegister } from '@/api/studio';
export default {
  components: {
    [MyUpload.name]: MyUpload,
  },
  data() {
    return {
      fileList: [],
      ruleForm: {
        contact: '',
        name: '',
        description: '',
        fileList: '',
      },
      upload_url: UPLOAD_URL,
      rules: {
        name: [
          { required: true, message: '请填写工作室名称', trigger: 'onBlur' },
          {
            min: 4,
            max: 50,
            message: '长度在 4 到 50 个字符',
            trigger: 'onBlur',
          },
        ],
        description: [
          {
            required: true,
            message: '简介信息请控制在 10 至 150 字之间',
            trigger: 'onBlur',
          },
        ],
        contact: [
          {
            required: true,
            validator: this.isValidContact,
            message: '请填写联系方式',
            trigger: 'onBlur',
          },
        ],
        fileList: [
          {
            type: 'string',
            required: true,
            message: '请上传工作室logo',
            trigger: 'onChange',
          },
        ],
      },
    };
  },
  methods: {
    onBeforeUpload(file) {
      return isValidFileSize(file.size, () =>
        this.$toast.fail('请限制文件大小在10M以内'),
      );
    },
    isValidContact(str) {
      if (isEmail(str) || isIntNum(str)) {
        return true;
      } else {
        this.$toast.fail('请填写正确的联系方式');
        return false;
      }
    },
    onChangeLogo(file, fileList) {
      console.log('onChangeLogo', file, fileList, this.ruleForm.fileList);
      if (file.status === 'success' && file.response.code === 200) {
        let { image } = file.response.data;
        this.fileList = [{ name: file.name, url: image.cdn_url }];
        this.ruleForm.fileList = JSON.stringify([
          { name: file.name, url: image.cdn_url },
        ]);
      }
    },
    onRemove(file) {
      let delIndex = -1;
      this.fileList.forEach((val, index) => {
        if (val.url === file.url) delIndex = index;
      });
      if (delIndex >= 0) {
        this.fileList.splice(delIndex, 1);
      }
    },
    submitForm() {
      console.log('submitForm', this.$refs['ruleForm'], this.ruleForm);
      let allValFilled = true;
      for (let key in this.ruleForm) {
        if (!this.ruleForm[key]) {
          allValFilled = false;
          this.$toast.fail(this.rules[key][0].message);
        }
      }
      if (allValFilled) {
        let params = Object.assign(
          { json: 1 },
          {
            name: this.ruleForm.name,
            description: this.ruleForm.description,
            head: this.fileList[0].url,
            contact: this.ruleForm.contact,
          },
        );
        studioRegister(params).then(res => {
          console.log('studioRegister', res);
          this.$toast.success('注册成功，请等待审核！');
          setTimeout(() => {
            this.$router.push({ name: 'creator' });
          }, 2000);
        });
      } else {
        return false;
      }
    },
    handleRemove() {
      console.log('delete', arguments, this.fileList);
    },
    handlePreview() {
      console.log('preview');
    },
    uploadSuccess(response, file, fileList) {
      console.log('uploadSuccess', response, file, fileList);
      if (response.code === 200) {
        let { image } = response.data;
        let { name, size } = file;
        console.log(name, size, image);
      }
    },
  },
};
</script>
<style
  src="../../../assets/styles/introduce-common.less"
  lang="less"
  scoped
></style>
<style lang="less" scoped>
.container {
  .block {
    min-height: calc(100vh - 115px);
    .title-wrap {
      .title-name {
        font-weight: 500;
        em {
          cursor: pointer;
        }
        label {
          color: #8c8c8c;
        }
      }
    }
    .content-inner-wrap {
      ::v-deep .el-upload-list.el-upload-list--picture {
        height: auto;
      }
      ::v-deep .van-button {
        width: 502px;
        height: 70px;
        font-size: 28px;
        line-height: 38px;
        border-radius: 8px;
        &.cancelBtn {
          background: #d9d9d9;
          border-color: #d9d9d9;
        }
      }
    }
  }
}
</style>
